export default __webpack_public_path__ + "static/media/Animations_Circle10.265b5acd.svg";